import { render, staticRenderFns } from "./VentasTab.vue?vue&type=template&id=40918f2d&scoped=true"
import script from "./VentasTab.vue?vue&type=script&lang=js"
export * from "./VentasTab.vue?vue&type=script&lang=js"
import style0 from "./VentasTab.vue?vue&type=style&index=0&id=40918f2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40918f2d",
  null
  
)

export default component.exports